export default {
  payOff: 'payOff',
  addMoney: 'addMoney',
  addressUpdate: 'addressUpdate',
};
